module.exports = __webpack_public_path__ + "img/china3d.41b3ee37.png";